function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { defineIntegration, convertIntegrationFnToClass, getCurrentScope } from '@sentry/core';
import { logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../debug-build.js';
import { startProfileForTransaction } from './hubextensions.js';
import { isAutomatedPageLoadTransaction, shouldProfileTransaction, getActiveProfilesCount, findProfiledTransactionsFromEnvelope, takeProfileFromGlobalCache, createProfilingEvent, addProfilesToEnvelope } from './utils.js';
var INTEGRATION_NAME = 'BrowserProfiling';

var _browserProfilingIntegration = function _browserProfilingIntegration() {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    setup: function setup(client) {
      var scope = getCurrentScope(); // eslint-disable-next-line deprecation/deprecation

      var transaction = scope.getTransaction();

      if (transaction && isAutomatedPageLoadTransaction(transaction)) {
        if (shouldProfileTransaction(transaction)) {
          startProfileForTransaction(transaction);
        }
      }

      if (typeof client.on !== 'function') {
        logger.warn('[Profiling] Client does not support hooks, profiling will be disabled');
        return;
      }

      client.on('startTransaction', function (transaction) {
        if (shouldProfileTransaction(transaction)) {
          startProfileForTransaction(transaction);
        }
      });
      client.on('beforeEnvelope', function (envelope) {
        // if not profiles are in queue, there is nothing to add to the envelope.
        if (!getActiveProfilesCount()) {
          return;
        }

        var profiledTransactionEvents = findProfiledTransactionsFromEnvelope(envelope);

        if (!profiledTransactionEvents.length) {
          return;
        }

        var profilesToAddToEnvelope = [];

        var _iterator = _createForOfIteratorHelper(profiledTransactionEvents),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var profiledTransaction = _step.value;
            var context = profiledTransaction && profiledTransaction.contexts;
            var profile_id = context && context['profile'] && context['profile']['profile_id'];
            var start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];

            if (typeof profile_id !== 'string') {
              DEBUG_BUILD && logger.log('[Profiling] cannot find profile for a transaction without a profile context');
              continue;
            }

            if (!profile_id) {
              DEBUG_BUILD && logger.log('[Profiling] cannot find profile for a transaction without a profile context');
              continue;
            } // Remove the profile from the transaction context before sending, relay will take care of the rest.


            if (context && context['profile']) {
              delete context.profile;
            }

            var profile = takeProfileFromGlobalCache(profile_id);

            if (!profile) {
              DEBUG_BUILD && logger.log("[Profiling] Could not retrieve profile for transaction: ".concat(profile_id));
              continue;
            }

            var profileEvent = createProfilingEvent(profile_id, start_timestamp, profile, profiledTransaction);

            if (profileEvent) {
              profilesToAddToEnvelope.push(profileEvent);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        addProfilesToEnvelope(envelope, profilesToAddToEnvelope);
      });
    }
  };
};

var browserProfilingIntegration = defineIntegration(_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation

var BrowserProfilingIntegration = convertIntegrationFnToClass(INTEGRATION_NAME, browserProfilingIntegration); // eslint-disable-next-line deprecation/deprecation

export { BrowserProfilingIntegration, browserProfilingIntegration };